import React from "react";
export default function () {
    return (
        <svg width="200" height="200" viewBox="0 0 200 200">
            <g>
                <g>
                    <path d="M33.2,90.7c-2.7-4.7-10.7-5.4-17.9-1.6S4.4,99.8,7,104.5s10.7,5.4,18,1.6S35.9,95.4,33.2,90.7Z" />
                    <rect x="32.1" y="23.2" width="1.9" height="71.82" />
                </g>
                <path d="M32.1,23.4H34S33,29,41.7,39.2,61,55,50.8,78.7c0,0-.5,1.3-1.6,1.3s-.7-.4-.2-1.5S60.8,53,34,44.8H32.1Z" />
            </g>
        </svg>
    );
}
